var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBalloon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.82288 41.3368C3.82288 18.9942 21.9351 0.882019 44.2776 0.882019C66.6202 0.882019 84.7324 18.9942 84.7324 41.3368V68.3066C84.7324 75.7541 78.695 81.7915 71.2475 81.7915H44.2776C21.9351 81.7915 3.82288 63.6793 3.82288 41.3368Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_89_392",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 82,
    height: 82
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.28949 43.9866C0.28949 21.644 18.4017 3.5318 40.7443 3.5318C63.0868 3.5318 81.199 21.644 81.199 43.9866V70.9564C81.199 78.4039 75.1616 84.4413 67.7141 84.4413H40.7443C18.4017 84.4413 0.28949 66.3291 0.28949 43.9866Z",
    fill: "url(#paint0_linear_89_392)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_89_392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.0987 -1.20731C29.7363 -1.85645 14.7743 4.50114 6.5126 13.6688C-8.89513 30.7628 -9.88722 55.2992 5.50612 72.7462C22.9757 92.5422 67.5165 114.285 87.1083 96.0921C97.268 86.6596 86.424 52.0791 84.4398 38.4386C82.5275 25.3049 73.5756 10.9982 61.6503 4.62926C56.4626 1.85902 47.9449 -0.89982 42.0959 -1.20731L42.0987 -1.20731Z",
    fill: "#F1EFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.25806 50.465C9.55509 50.5125 21.3692 50.5599 33.1843 50.6074C33.7105 58.807 33.2734 67.0323 33.2562 75.2348C33.2562 76.4819 33.0578 85.3079 33.4719 85.6268C34.3346 86.2873 44.4741 86.5578 46.1966 85.5556C46.2196 73.9071 46.2436 62.2577 46.2685 50.6074L81.8546 50.3938C82.1163 48.9162 82.4183 38.8488 81.639 38.5072L46.1966 38.2936L45.9809 2.06423C44.4108 1.54321 33.6386 1.40085 33.2562 2.13541C33.3041 14.1407 33.352 26.146 33.4 38.1513C21.443 38.269 9.48512 38.3876 -2.47374 38.5072L-2.8332 38.8631C-2.95397 43.2334 -2.88496 46.1602 -2.25806 50.465Z",
    fill: "url(#paint1_linear_89_392)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8773 3.0636C23.3668 5.02525 17.0404 7.81257 11.8326 12.2455C17.8945 17.1558 23.9573 22.0671 30.0211 26.9793L29.8773 3.0636Z",
    fill: "#133A75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.357 65.9816C49.4116 63.906 49.0694 63.5758 49.8602 63.8463C50.8465 64.1851 64.0055 75.2518 66.1795 76.7294L65.6044 77.2276C65.6504 77.1906 65.9121 77.2704 65.9638 77.2276C66.723 76.6098 69.9466 72.5413 71.3557 72.1029C70.8122 71.7071 63.5425 64.9822 61.3628 63.1345C57.8861 60.1877 54.2542 57.3862 50.651 54.5932L50.7229 54.0237C55.692 54.3597 49.9091 52.7938 52.8077 51.9596C51.6316 51.3475 52.4396 50.9033 52.1607 50.7496C51.9134 50.6129 47.2462 50.8008 46.4813 50.8207L46.4813 66.1951C46.6481 66.5311 48.9256 66.2264 49.357 65.9816Z",
    fill: "#F1EFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3569 65.9815C49.1844 72.3704 49.3397 78.8106 49.5726 85.1995C55.3728 83.6023 59.321 109.862 64.0227 106.092L79.0284 87.2348C76.8544 85.7572 50.8465 64.185 49.8602 63.8462C49.0694 63.5757 49.4116 63.906 49.3569 65.9815Z",
    fill: "#19193F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.965 52.664C109.76 52.6868 68.2173 54.6396 62.0097 54.6643C66.7085 58.3257 89.2469 77.8871 93.4569 82.0923C95.6596 78.3996 114.812 56.8094 115.965 52.664Z",
    fill: "#133A75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6496 54.5932C54.2528 57.3862 57.8847 60.1878 61.3614 63.1345C63.5411 64.9823 70.8108 71.7072 71.3543 72.1029C76.1275 75.5785 89.853 87.9911 90.27 87.6352C102.852 99.4938 93.167 84.9495 92.9686 84.175C92.7127 83.1843 59.7741 55.5897 58.9171 55.0203C58.7244 54.8922 58.2413 54.4651 58.1982 54.4509C57.8387 54.3284 51.357 54.1633 50.6496 54.5932Z",
    fill: "#C72543"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.58447 18.2957C5.60292 19.5522 4.62041 20.8097 3.63694 22.0681C5.54637 23.617 18.4034 34.2851 19.3811 34.5242C20.1489 34.7121 24.9742 34.436 26.3546 34.453L6.58447 18.2957Z",
    fill: "#C72543"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.40196 50.7498C-2.17191 52.1819 -1.61691 53.4973 -1.53927 54.9493L-1.2517 55.0205L-1.17981 54.4511L15.4989 54.4511C14.1273 56.4099 11.3638 57.4291 9.81954 59.2911C8.69229 60.6492 9.60962 59.3822 10.4666 60.7147C11.6082 61.0934 11.4644 60.188 12.1919 59.7182C12.3041 59.6442 12.6722 59.7011 13.0546 59.4335C14.0784 58.7132 19.2545 54.1322 19.6686 54.024C20.399 53.8361 25.3624 54.1635 27.0015 54.024C27.9476 54.4055 26.5989 55.345 24.9886 56.7287C19.3926 61.5403 13.1927 65.7057 7.6628 70.6084C7.59954 70.9785 12.261 76.0065 12.6233 76.0891C13.2991 76.2428 13.5464 75.2719 13.5579 75.9467C14.2567 75.1808 27.6687 65.4323 30.0929 63.4194C30.6766 64.2195 30.2021 65.4694 30.2366 66.9071C30.2366 67.0153 30.5213 66.9413 30.5242 67.0495C30.5357 67.5762 30.2338 67.3655 30.2366 67.4766C30.2711 69.2759 30.4954 71.081 30.3804 72.8861C31.3581 72.5843 30.8031 70.7422 30.8118 70.6084C30.8348 70.2269 31.1712 70.4945 31.2431 70.3237C31.2949 70.1984 30.6594 70.1813 30.9555 68.7578C31.1195 68.4474 32.5199 68.5044 32.609 68.5442C33.0404 68.7464 32.5774 69.4952 33.1123 69.3984C33.1123 63.1831 33.1727 56.965 33.0404 50.7498L-2.40196 50.7498Z",
    fill: "#F1EFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5579 75.9466C13.3681 76.1545 13.0776 76.4819 13.1984 76.5161C18.0669 80.5817 23.7808 83.4488 29.8772 85.1997L30.0928 63.4194C27.6687 65.4323 14.2566 75.1808 13.5579 75.9466Z",
    fill: "#19193F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5508 54.3086C22.228 54.2716 20.8362 54.2232 19.5249 54.451L4.21204 66.9071C5.28945 68.0687 6.36782 69.2313 7.44715 70.3948L27.2172 54.5222C26.0037 54.5222 24.7557 54.34 23.5508 54.3086Z",
    fill: "#AB0F25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.25169 55.0203C-0.351608 58.3685 1.01145 61.5999 2.84611 64.5581L9.81956 59.2909C11.3638 57.4289 14.1273 56.4097 15.499 54.4509L-1.17979 54.4509L-1.25169 55.0203Z",
    fill: "#19193F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.41483 24.5591C1.73042 24.5762 -1.61108 33.2058 -1.46729 34.524L14.9958 34.4528C10.8031 31.1559 6.60944 27.858 2.41483 24.5591Z",
    fill: "#19193F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7164 2.92133C49.6685 10.9407 49.6205 18.96 49.5726 26.9794C55.5866 22.0691 61.6015 17.1578 67.6173 12.2456C62.7115 7.49093 56.1291 4.99971 49.7164 2.92133Z",
    fill: "url(#paint2_linear_89_392)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2967 18.438C66.2763 23.8228 59.2549 29.2086 52.2326 34.5953C53.7969 34.453 59.0939 34.7946 59.6373 34.6665C60.6438 34.4302 73.8948 23.5229 75.8129 21.9257L73.2967 18.438Z",
    fill: "url(#paint3_linear_89_392)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0351 24.7017C72.7465 27.9512 68.457 31.2016 64.1666 34.453L80.7734 34.5242C80.6757 33.3426 77.5556 24.8013 77.0351 24.7017Z",
    fill: "#476097"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.40183 50.7499L33.0405 50.7499C33.1728 56.9651 33.1124 63.1832 33.1124 69.3984C33.1124 71.3344 32.9945 73.3075 33.2562 75.235C33.2735 67.0325 33.7106 58.81 33.1843 50.6075C21.3711 50.5601 9.55703 50.5126 -2.25805 50.4651C-2.25805 50.4822 -2.45647 50.4111 -2.40183 50.7499Z",
    fill: "#F9DDDF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_89_392",
    x1: 20.4876,
    y1: 3.5318,
    x2: 30.8021,
    y2: 88.8629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C5C5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_89_392",
    x1: 65.9034,
    y1: 22.3755,
    x2: 13.6214,
    y2: 66.1041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D83C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#AA102A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_89_392",
    x1: 59.022,
    y1: 7.15497,
    x2: 47.9491,
    y2: 20.8069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F679C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#324E8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_89_392",
    x1: 73.8517,
    y1: 21.8175,
    x2: 57.0808,
    y2: 32.8407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E45F79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D13250"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalloon);
export default __webpack_public_path__ + "static/media/balloon.3df0a93dc484d98290fe9dfd27a65471.svg";
export { ForwardRef as ReactComponent };